import { useQueryClient } from '@tanstack/react-query';
import { produce } from 'immer';
import { gql } from '@/utilities/gql';
import { makeGqlMutation } from '@/utilities/gqlQuery';

import type { PortfolioQueryClientData } from '@/hooks/portfolio/usePortfolio';
import {
  PORTFOLIO_QUERY_KEY,
  PORTFOLIO_FRAGMENT,
  PORTFOLIOS_QUERY_KEY,
} from '@/hooks/portfolio/usePortfolio';

import type { VariablesOf } from '@/utilities/gql';

const MUTATION = gql(
  `
    mutation updatePortfolioBenchmark(
        $id: String!
        $benchmark: String!
        $benchmarkType: BenchmarkType!
    ) {
        updatePortfolioBenchmark(
            id: $id
            benchmark: $benchmark
            benchmarkType: $benchmarkType
        ) {
            ...portfolioFields
        }
    }
`,
  [PORTFOLIO_FRAGMENT]
);

export type BenchmarkType = VariablesOf<typeof MUTATION>['benchmarkType'];

const mutation = makeGqlMutation(MUTATION);

export const useUpdatePortfolioBenchmark = () => {
  const queryClient = useQueryClient();

  return mutation({
    onMutate: (payload) => {
      queryClient.setQueriesData<PortfolioQueryClientData>(
        { queryKey: [PORTFOLIO_QUERY_KEY, payload.id] },
        (state) =>
          produce(state, (draft) => {
            if (typeof draft === 'undefined') {
              return draft;
            }
            draft.analysis.benchmark = payload.benchmark;
            draft.analysis.benchmarkType = payload.benchmarkType;
          })
      );
    },
    onSettled: (_, __, { id }) => {
      queryClient.invalidateQueries({ queryKey: [PORTFOLIO_QUERY_KEY, id] });
      queryClient.invalidateQueries({ queryKey: PORTFOLIOS_QUERY_KEY });
    },
  });
};
